import { render, staticRenderFns } from "./ModalPaymentQR.vue?vue&type=template&id=1cb03b6a&"
import script from "./ModalPaymentQR.vue?vue&type=script&lang=js&"
export * from "./ModalPaymentQR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports